import { Injectable } from '@angular/core';
declare var $: any;

@Injectable({ providedIn: 'root' })
export class AlertService {

  // convenience methods
  success(message: string) {
    this.showNotification(message, 'success');
  }

  error(message: string) {
    this.showNotification(message, 'danger');
  }

  info(message: string) {
    this.showNotification(message, 'primary');
  }

  warn(message: string) {
    this.showNotification(message, 'warning');
  }

  // main alert method    
  alert(message: string) {
    this.info(message)
  }

  // --------------------------------------------------------------------------------------------
  showNotification(message: string, type: string = 'info', from = 'bottom', align = 'right') {

    //return console.log(message);
    
    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div style="z-index: 20000 !important" data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}